import config from "../config";
import { ListActionProvider } from "@beeldit/core/actions/list/ListActionContext";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import { PayActionProvider } from "../actions/pay/PayActionContext";
import BookingsTablePage from "../components/BookingsTablePage";
import { GenerateDeliveryNoteActionProvider } from "../actions/generate-delivery-note/GenerateDeliveryNoteActionContext";
import { GenerateInvoiceActionProvider } from "../actions/generate-invoice/GenerateInvoiceActionContext";
import { GenerateInvoicePdfActionProvider } from "../actions/generate-invoice-pdf/GenerateInvoicePdfActionContext";
import { RegenerateInvoicePdfActionProvider } from "../actions/regenerate-invoice-pdf/RegenerateInvoicePdfActionContext";
import { BulkActionActionProvider } from "@beeldit/core/context/BulkActionContext";
import { CreateActionProvider } from "../actions/create/CreateActionContext";
import { CancelActionProvider } from "../actions/cancel/CancelActionContext";
import { UncancelActionProvider } from "../actions/uncancel/UncancelActionContext";
import { EditActionProvider } from "../actions/edit/EditActionContext";
import { EditActionProvider as CustomerEditActionProvider } from "@main/customers/actions/edit/EditActionContext";
import { UnpayActionProvider } from "../actions/unpay/UnpayActionContext";
import { EmailActionProvider } from "../actions/email/EmailActionContext";

function BookingsPage() {
  const tablePageParams = {
    modelConfig: config, // Configuración del modelo
    formDefaultValues: null,
    filters: null,
    formFilterValues: null,
  };

  return (
    <BulkActionActionProvider>
      <ListActionProvider key={config.modelName}>
        <RemoveActionProvider>
          <CreateActionProvider>
            <PayActionProvider>
              <UnpayActionProvider>
              <GenerateDeliveryNoteActionProvider>
                <GenerateInvoiceActionProvider>
                <CustomerEditActionProvider>
                <EditActionProvider>
                  <CancelActionProvider>
                    <UncancelActionProvider>
                      <EmailActionProvider>
                        <GenerateInvoicePdfActionProvider>
                          <RegenerateInvoicePdfActionProvider>
                            <BookingsTablePage {...tablePageParams} />
                          </RegenerateInvoicePdfActionProvider>
                        </GenerateInvoicePdfActionProvider>
                      </EmailActionProvider>
                    </UncancelActionProvider>
                  </CancelActionProvider>
                </EditActionProvider>
                </CustomerEditActionProvider>
                </GenerateInvoiceActionProvider>
              </GenerateDeliveryNoteActionProvider>
              </UnpayActionProvider>
            </PayActionProvider>
          </CreateActionProvider>
        </RemoveActionProvider>
      </ListActionProvider>
    </BulkActionActionProvider>
  );
}

export default BookingsPage;
